import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  FileShareResponse,
  LinkFileRequest,
  LinkFileResponse,
  PaginatedLeadFileResponse,
  ShareFileRequest,
} from '../models/lead-file';

@Injectable({
  providedIn: 'root',
})
export class LeadFileService {
  private apiUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getLeadFiles(
    uniqueId: string,
    page = 1,
    pageSize = 10,
  ): Observable<PaginatedLeadFileResponse> {
    return this.http.get<PaginatedLeadFileResponse>(
      `${this.apiUrl}/api/record/${uniqueId}/files`,
      {
        params: {
          page: page.toString(),
          page_size: pageSize.toString(),
        },
        headers: { 'X-Skip-Loader': 'true' },
      },
    );
  }

  linkFileToLead(
    uniqueId: string,
    payload: LinkFileRequest,
  ): Observable<LinkFileResponse> {
    return this.http.post<LinkFileResponse>(
      `${this.apiUrl}/api/record/${uniqueId}/files`,
      payload,
    );
  }

  removeFileFromLead(uniqueId: string, leadFileId: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/api/record/${uniqueId}/files/${leadFileId}`,
    );
  }

  getShareDetails(
    uniqueId: string,
    leadFileId: number,
  ): Observable<FileShareResponse> {
    return this.http.get<FileShareResponse>(
      `${this.apiUrl}/api/record/${uniqueId}/files/${leadFileId}/share`,
    );
  }

  updateSharing(
    uniqueId: string,
    leadFileId: number,
    payload: ShareFileRequest,
  ): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.apiUrl}/api/record/${uniqueId}/files/${leadFileId}/share`,
      payload,
    );
  }
}
